import React from "react";
import { useRecover } from "../hooks/useRecover";
import { Box, Button, HStack, PinInput, PinInputField } from "@chakra-ui/react";

type CodeFormProps = Pick<useRecover.type, "state" | "changeCodeInput" | "codeValidate" | "sendCode" | "backward">

export const CodeForm: React.FC<CodeFormProps> = ({ state, changeCodeInput, codeValidate, sendCode, backward }) => {

    const { loading } = state;

    return (
        <Box mt="24px">

            <HStack>
                <PinInput size='lg' onChange={(value) => changeCodeInput(value)} isInvalid={!codeValidate()}>
                    <PinInputField />
                    <PinInputField />
                    <PinInputField />
                    <PinInputField />
                    <PinInputField />
                    <PinInputField />
                </PinInput>
            </HStack>

            <Button
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mt="24px"
                isLoading={loading}
                onClick={sendCode}
            >
                SEGUIR
            </Button>

            <Button
                fontSize="sm"
                variant="outline"
                fontWeight="500"
                w="100%"
                h="50"
                mt="24px"
                isLoading={loading}
                onClick={backward}
            >
                Voltar
            </Button>
        </Box>
    );
}